import React, { useEffect, useState } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Avatar, Checkbox, Tooltip } from "antd";
import { getInitials } from "../../../../../utils";
import { UserOutlined } from "@ant-design/icons";

export function Item({ data, taskDetailHandler = () => {}, fromDraggable }) {
  // STATES
  const [isCompleted, setCompleted] = useState(false);

  // CONST VALS
  const { http } = global.services;

  // HANDLERS
  const openDetailHandler = () => {
    taskDetailHandler(data);
  };
  const markCompleteHandler = (e) => {
    const val = e.checked;
    setCompleted(val);
    http
      .post(`company-task-complete/${data.id}`, { completed: val })
      .then(() => {})
      .catch(() => {
        setCompleted(!val);
      });
  };

  // HOOKS
  useEffect(() => {
    setCompleted(data?.is_completed);
  }, [data]);

  return (
    <div
      className={`draggable-task ${isCompleted ? "completed" : ""} ${
        fromDraggable ? "disabled" : ""
      }`}
      onClick={openDetailHandler}
    >
      <div className="mark-complete-checkbox">
        <Tooltip title={isCompleted ? "Mark as incomplete" : "Mark as complete"}>
          <Checkbox
            checked={isCompleted}
            onClick={(e) => e.stopPropagation()}
            onChange={({ target }) => markCompleteHandler(target)}
          />
        </Tooltip>
      </div>
      <div className="inner-content">
        <h4>
          {data?.title?.length > 50 ? (
            <Tooltip title={data?.title}>{data?.title.slice(0, 50)}...</Tooltip>
          ) : (
            data?.title
          )}
        </h4>
        <span className="tag">{data?.tag}</span>
        <div className="assignees">
          {data?.task_assignees?.length === 0 && <Avatar icon={<UserOutlined />} />}
          <Avatar.Group max={3}>
            {data?.task_assignees?.slice(0, 3)?.map(({ assignee }, index) => (
              <Tooltip title={assignee.username} key={index}>
                <Avatar style={{ backgroundColor: "#eab8ff" }}>
                  {getInitials(assignee.username)}
                </Avatar>
              </Tooltip>
            ))}
          </Avatar.Group>
          <p>
            {data?.task_assignees.length === 0
              ? "Unassigned"
              : data?.task_assignees.length === 1
              ? `${data?.task_assignees[0].assignee.username}`
              : data?.task_assignees.length > 3
              ? `+${data?.task_assignees.length - 3} more`
              : ""}
          </p>
        </div>
      </div>
    </div>
  );
}

export default function SortableItem({ id, data, taskDetailHandler }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Item id={id} data={data} taskDetailHandler={taskDetailHandler} />
    </div>
  );
}
